const AUTHENTICATION_TOKEN = 'MyToken';
const AUTHENTICATION_SESSION_ID = 'SessionID';

async function setToken(token) {
  try {
    await localStorage.setItem(AUTHENTICATION_TOKEN, token);
  } catch (error) { }
}

async function setSessionID(sessionID) {
  try {
    await localStorage.setItem(AUTHENTICATION_SESSION_ID, sessionID);
  } catch (error) { }
}

async function setRegistrationNRIC(nric) {
  try {
    await localStorage.setItem('RegistrationNRIC', nric);
  } catch (error) { }
}

async function setRegistrationEmail(email) {
  try {
    await localStorage.setItem('RegistrationEmail', email);
  } catch (error) { }
}

async function setRegistrationDOB(dob) {
  try {
    await localStorage.setItem('RegistrationDOB', dob);
  } catch (error) { }
}

async function setNeedChangeUserID(needChangeUserID) {
  try {
    await localStorage.setItem('NeedChangeUserID', needChangeUserID);
  } catch (error) { }
}

async function setSetChangeUserID(needSetUserId) {
  try {
    await localStorage.setItem('NeedSetUserId', needSetUserId);
  } catch (error) { }
}
async function setIsMasterAccount(isMasterAccount) {
  try {
    await localStorage.setItem('IsMasterAccount', isMasterAccount);
  } catch (error) { }
}

async function removeToken(token) {
  try {
    await localStorage.removeItem(AUTHENTICATION_TOKEN);
  } catch (error) { }
}

async function retrieveToken() {
  try {
    return await localStorage.getItem(AUTHENTICATION_TOKEN);
  } catch (error) { }
}

async function retrieveTokenSession() {
  try {
    return await sessionStorage.getItem(AUTHENTICATION_TOKEN);
  } catch (error) { }
}

async function setNric(nric) {
  try {
    return await localStorage.setItem('NRIC', nric);
  } catch (error) { }
}
async function setOtpReference(otpRef) {
  try {
    return await localStorage.setItem('OtpRef', otpRef);
  } catch (error) { }
}
async function setUserID(userID) {
  try {
    return await localStorage.setItem('UserID', userID);
  } catch (error) { }
}
async function setPassword(password) {
  try {
    return await localStorage.setItem('Password', password);
  } catch (error) { }
}
async function setMobilePhoneLabel(mobilePhoneLabel) {
  try {
    return await localStorage.setItem('MobilePhoneLabel', mobilePhoneLabel);
  } catch (error) { }
}
async function setPolicyNo(policyNo) {
  try {
    return await localStorage.setItem('PolicyNo', policyNo);
  } catch (error) { }
}
async function setResendOtpReference(resendOtpReference) {
  try {
    return await localStorage.setItem('ResendOtpReference', resendOtpReference);
  } catch (error) { }
}
async function setResendOtp(resendOtp) {
  try {
    return await localStorage.setItem('ResendOtp', resendOtp);
  } catch (error) { }
}
async function setClientMobileNo(clientMobileNo) {
  try {
    return await localStorage.setItem('ClientMobileNo', clientMobileNo);
  } catch (error) { }
}
async function setMobileCountryCode(mobileCountryCode) {
  try {
    return await localStorage.setItem('MobileCountryCode', mobileCountryCode);
  } catch (error) { }
}
async function setName(name) {
  try {
    return await localStorage.setItem('Name', name);
  } catch (error) { }
}
async function setIsEditableNameorDOB(isEditable) {
  try {
    return await localStorage.setItem('IsEditableNameAndDOB', isEditable);
  } catch (error) { }
}

async function retrieveMobileCountryCode() {
  try {
    return await localStorage.getItem('MobileCountryCode');
  } catch (error) { }
}
async function retrieveNric() {
  try {
    return await localStorage.getItem('NRIC');
  } catch (error) { }
}
async function retrieveOtpReference() {
  try {
    return await localStorage.getItem('OtpRef');
  } catch (error) { }
}
async function retrieveUserID() {
  try {
    return await localStorage.getItem('UserID');
  } catch (error) { }
}
async function retrievePassword() {
  try {
    return await localStorage.getItem('Password');
  } catch (error) { }
}
async function retrieveMobilePhoneLabel() {
  try {
    return await localStorage.getItem('MobilePhoneLabel');
  } catch (error) { }
}
async function retrievePolicyNo() {
  try {
    return await localStorage.getItem('PolicyNo');
  } catch (error) { }
}
async function retrieveResendOtpReference() {
  try {
    return await localStorage.getItem('ResendOtpReference');
  } catch (error) { }
}
async function retrieveResendOtp() {
  try {
    return await localStorage.getItem('ResendOtp');
  } catch (error) { }
}
async function retrieveClientMobileNo() {
  try {
    return await localStorage.getItem('ClientMobileNo');
  } catch (error) { }
}


async function removeMobileCountryCode() {
  try {
    return await localStorage.removeItem('MobileCountryCode');
  } catch (error) { }
}
async function removeNric() {
  try {
    return await localStorage.removeItem('NRIC');
  } catch (error) { }
}
async function removeReference() {
  try {
    return await localStorage.removeItem('OtpRef');
  } catch (error) { }
}
async function removeUserID() {
  try {
    return await localStorage.removeItem('UserID');
  } catch (error) { }
}
async function removePassword() {
  try {
    return await localStorage.removeItem('Password');
  } catch (error) { }
}
async function removeMobilePhoneLabel() {
  try {
    return await localStorage.removeItem('MobilePhoneLabel');
  } catch (error) { }
}
async function removePolicyNo() {
  try {
    return await localStorage.removeItem('PolicyNo');
  } catch (error) { }
}
async function removeResendOtpReference() {
  try {
    return await localStorage.removeItem('ResendOtpReference');
  } catch (error) { }
}
async function removeResendOtp() {
  try {
    return await localStorage.removeItem('ResendOtp');
  } catch (error) { }
}
async function removeClientMobileNo() {
  try {
    return await localStorage.removeItem('ClientMobileNo');
  } catch (error) { }
}
async function setDirectClient(isDirectClient) {
  try {
    return await localStorage.setItem('IsDirectClient', isDirectClient);
  } catch (error) { }
}
async function setExpiryWarning(expiryWarning) {
  try {
    return await localStorage.setItem('ExpiryWarning', expiryWarning);
  } catch (error) { }
}
async function setExpiryEnd(expiryEnd) {
  try {
    return await localStorage.setItem('ExpiryEnd', expiryEnd);
  } catch (error) { }
}

async function setDOB(dob) {
  try {
    return await localStorage.setItem('DOB', dob);
  } catch (error) { }
}
async function setIsDirectClient(directClient) {
  try {
    return await localStorage.setItem('isDirectClient', directClient);
  } catch (error) { }
}
async function retrieveIsDirectClient() {
  try {
    return await localStorage.getItem('isDirectClient');
  } catch (error) { }
}
async function retrieveDOB() {
  try {
    return await localStorage.getItem('DOB');
  } catch (error) { }
}
async function removeDOB() {
  try {
    return await localStorage.removeItem('DOB');
  } catch (error) { }
}

async function setOtpCode(otpC) {
  try {
    return await localStorage.setItem('otpCode', otpC);
  } catch (error) { }
}
async function retrieveOtpCode() {
  try {
    return await localStorage.getItem('otpCode');
  } catch (error) { }
}

async function removeOtpCode() {
  try {
    return await localStorage.removeItem('otpCode');
  } catch (error) { }
}

export default {
  setToken,
  removeToken,
  retrieveToken,
  setSessionID,
  setRegistrationEmail,
  setRegistrationDOB,
  setRegistrationNRIC,
  setNeedChangeUserID,
  setNric,
  setOtpReference,
  setUserID,
  setPassword,
  setMobilePhoneLabel,
  setPolicyNo,
  setResendOtpReference,
  setResendOtp,
  setClientMobileNo,
  retrieveNric,
  retrieveOtpReference,
  retrieveUserID,
  retrievePassword,
  retrieveMobilePhoneLabel,
  retrievePolicyNo,
  retrieveResendOtpReference,
  retrieveResendOtp,
  retrieveClientMobileNo,
  removeNric,
  removeReference,
  removeUserID,
  removePassword,
  removeMobilePhoneLabel,
  removePolicyNo,
  removeResendOtpReference,
  removeResendOtp,
  removeClientMobileNo,
  setMobileCountryCode,
  retrieveMobileCountryCode,
  removeMobileCountryCode,
  setName,
  setIsEditableNameorDOB,
  setSetChangeUserID,
  setIsMasterAccount,
  setDirectClient,
  setExpiryWarning,
  setExpiryEnd,
  setDOB,
  retrieveDOB,
  removeDOB,
  setIsDirectClient,
  retrieveIsDirectClient,
  retrieveTokenSession,
  setOtpCode,
  retrieveOtpCode,
  removeOtpCode,
}